import * as React from 'react';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { UilPen } from '@iconscout/react-unicons';
import * as uuid from 'uuid';
import * as classnames from 'classnames';
import Notes from '../../../../common/notes/Notes';
import { updateProject } from '../../../../../services/project.service';
import NotifyHOC from '../../../../../HOC/Notifications';
import { IApplicationState } from '../../../../../reducers';
import * as Actions from '../../../../../actions/project.actions';
import {
    cancelEditQuestion,
    previewQuestion
} from '../../../../../services/question.service';
import {
    MULTIMEDIA_TYPES,
    OPTION_SIZE,
    Project,
    ProjectID,
    PROJECT_EDIT_STATUS
} from '@nexxt/common/types';
import BuilderHeader from '../../common/builderHeader';
import {
    setEditedStatus,
    clearEditedStatus
} from '../../../../../services/utils.service';
import { getConfirmationBox } from '../../../../common/swal/Sweetalert';
import InputRadio from '../../common/radioButton/inputRadio';
import { alertMessage } from '../../../../../constants/alertMessage';
import { questionErrorMessage } from '../../../../../constants/applicationMessage';
import { createNewRichTextObject } from '@nexxt/common/services/TextService';
import MediaManager from '../../../../libraries/mediaLibrary/MediaManager';
import MultimediaBubble from '../../common/MultimediaBubble';
import AutoSavingService from '../../../../../utils/AutoSavingService';
import ValidationService from '@nexxt/common/services/ValidationService';
import HelperTooltip from '../../../../common/HelperTooltip';
import { INCA_LOGO_URL } from '@nexxt/common/constants';
export interface IGreetingTextProps {
    currentProject: any;
    toastNotification: any;
    notify: any;
    packageID: number;
    editEnabled: boolean;
    editStatus: PROJECT_EDIT_STATUS;
    setProject: (project: Project) => void;
    updateProject: (projectID: ProjectID, project: Project) => Promise<any>;
    previewQuestion: (projectId: number, questionId: number) => Promise<any>;
    setEditedStatus: (type: string, status: string) => Promise<any>;
    clearEditedStatus: (status?: PROJECT_EDIT_STATUS) => Promise<any>;
    cancelEditQuestion: () => Promise<any>;
    isEdited: boolean;
}

export interface IGreetingTextStates {
    showError: boolean;
    isSaving: boolean;
    projectError: any;
    project: any;
    isMediaLibraryOpen: boolean;
    questionError: any;
    autoSavingService: AutoSavingService<Project>;
}
interface IGreetingImageProps {
    greetingImage?: string;
    disabled: boolean;
    setSelectMedia: ({ src: string }) => void;
}

export const GreetingImage: React.SFC<IGreetingImageProps> = ({
    disabled,
    greetingImage,
    setSelectMedia
}) => {
    const [openMediaManager, setOpenMediaManager] = React.useState(false);
    return (
        <div className="col-md-12 form-group">
            {/* <label className="form-group__label form-group__label--block">
                    Greeting Image <i>(optional)</i>
                </label> */}
            <span className="form-group__icon">
                <MediaManager
                    showMediaManager={openMediaManager}
                    toggleMediaManager={setOpenMediaManager}
                    applyCurrentMedia={({ mediaURL }) =>
                        setSelectMedia({ src: mediaURL })
                    }
                    showMediaLibrary
                    type="image"
                >
                    <div>
                        <img
                            src={greetingImage ? greetingImage : INCA_LOGO_URL}
                        />
                        <div
                            className={classnames('hover-container', {
                                disabled
                            })}
                            onClick={() => setOpenMediaManager(true)}
                        >
                            <div
                                className={classnames('hover-container--item', {
                                    disabled
                                })}
                            >
                                <UilPen size={16} />
                            </div>
                        </div>
                    </div>
                </MediaManager>
            </span>
        </div>
    );
};

export class GreetingText extends React.Component<
    IGreetingTextProps,
    IGreetingTextStates
> {
    private validationService;
    constructor(props: IGreetingTextProps) {
        super(props);
        const project = this.parseGreetingTexts(this.props.currentProject);
        this.validationService = new ValidationService();
        this.state = {
            showError: true,
            isSaving: false,
            projectError: {},
            project,
            isMediaLibraryOpen: false,
            questionError: {},
            autoSavingService: new AutoSavingService(
                project,
                `question|greetings`,
                false,
                this.props.editStatus,
                this.props.setEditedStatus,
                this.props.clearEditedStatus
            )
        };
    }
    componentDidMount(): void {
        this.state.autoSavingService.setAutoSavingInterval(this.onSave);
        this.isValid();
    }
    componentDidUpdate(
        prevProps: Readonly<IGreetingTextProps>,
        prevState: Readonly<IGreetingTextStates>,
        snapshot?: any
    ): void {
        this.state.autoSavingService.setData(this.state.project);

        if (!_.isEqual(prevProps.editStatus, this.props.editStatus)) {
            this.state.autoSavingService.setCurrentEditStatus(
                this.props.editStatus
            );
        }

        if (prevState.isSaving !== this.state.isSaving) {
            this.state.autoSavingService.setIsSaving(this.state.isSaving);
        }
    }
    componentWillUnmount() {
        this.state.autoSavingService &&
            this.state.autoSavingService.clearAutoSaving();
    }

    parseGreetingTexts = (project) => {
        let greetingText = project.greetingText;
        if (greetingText && !Array.isArray(greetingText)) {
            greetingText = [greetingText];
        }
        return {
            ...project,
            greetingText
        };
    };
    setEditFlag = () => {
        this.state.autoSavingService.setEditing();
        const isValid = this.isValid();
        this.state.autoSavingService.setEditFlag(isValid);
    };

    setQuestion = (keyName: string, value: any): void => {
        if (this.state.isSaving) {
            return;
        }
        this.setState(
            {
                ...this.state,
                project: {
                    ...this.state.project,
                    [keyName]: value
                }
            },
            this.setEditFlag
        );
    };

    setGreetingTexts = (
        keyName: string,
        value: any,
        language: string,
        index: number,
        type = MULTIMEDIA_TYPES.RICH_TEXT
    ): void => {
        const { project } = this.state;
        const currentObject = project[keyName] || [];
        let uploadedValue = false;
        let newFields = currentObject.filter(
            (current) => current.language === language
        )[0];

        switch (type) {
            case MULTIMEDIA_TYPES.RICH_TEXT:
                newFields = newFields || {
                    language,
                    contents: [{ type, richText: {}, id: uuid.v4() }]
                };
                newFields.contents = [
                    ...newFields.contents.slice(0, index),
                    { ...newFields.contents[index], type, richText: value },
                    ...newFields.contents.slice(index + 1)
                ];
                break;
            case MULTIMEDIA_TYPES.IMAGE:
            case MULTIMEDIA_TYPES.AUDIO:
            case MULTIMEDIA_TYPES.VIDEO:
                newFields.contents = [
                    ...newFields.contents.slice(0, index),
                    { ...newFields.contents[index], type, ...value },
                    ...newFields.contents.slice(index + 1)
                ];
                break;
            case MULTIMEDIA_TYPES.TEXT:
                newFields = newFields || {
                    language,
                    contents: [{ type, text: '' }]
                };
                newFields.contents = [
                    ...newFields.contents.slice(0, index),
                    { type, text: value },
                    ...newFields.contents.slice(index + 1)
                ];
                break;
        }

        const currentLanguage = currentObject.map((current) => {
            if (current.language === language) {
                uploadedValue = true;

                return { ...current, contents: newFields.contents };
            }
            return current;
        });

        if (!uploadedValue) {
            currentObject.push(newFields);
            this.setQuestion(keyName, currentObject);
            return;
        }

        this.setQuestion(keyName, [...currentLanguage]);
    };
    isValid = () => {
        let error: any = {
            greetingText: '',
            greetingLabel: '',
            greetingImage: '',
            typistText: '',
            greetingType: '',
            isError: false
        };
        const { isEmpty, validateGreetingTexts } = this.validationService;
        if (typeof this.state.project.greetingText === 'string') {
            error = {
                ...error,
                greetingText: questionErrorMessage.REQUIRED,
                isError: true
            };
        }
        if (isEmpty(this.state.project.greetingLabel)) {
            error = {
                ...error,
                greetingLabel: questionErrorMessage.REQUIRED,
                isError: true
            };
        }
        if (isEmpty(this.state.project.greetingType)) {
            error = {
                ...error,
                greetingType: questionErrorMessage.REQUIRED,
                isError: true
            };
        }
        if (this.state.project.greetingType === 'image') {
            if (isEmpty(this.state.project.greetingImage)) {
                error = {
                    ...error,
                    greetingImage: questionErrorMessage.REQUIRED,
                    isError: true
                };
            }
        }

        if (this.state.project.greetingType === 'text') {
            if (isEmpty(this.state.project.typistText)) {
                error = {
                    ...error,
                    typistText: questionErrorMessage.REQUIRED,
                    isError: true
                };
            }
        }
        const greetingTextValidation = validateGreetingTexts(
            this.state.project.greetingText,
            this.state.project.languages
        );
        if (greetingTextValidation.isError) {
            error = {
                ...error,
                greetingText: greetingTextValidation,
                isError: true
            };
        }
        this.setState({
            projectError: error
        });
        return error;
    };

    openMediaLibrary = (value) => {
        this.setState({
            isMediaLibraryOpen: true
        });
    };

    setSelectedMedia = (newMedia) => {
        this.setState({
            project: {
                ...this.state.project,
                greetingImage: newMedia.src
            }
        });
    };

    closeModal = () => {
        this.setState({
            isMediaLibraryOpen: false
        });
    };

    addNewEditor = (
        languageCode: string,
        position: number,
        type = MULTIMEDIA_TYPES.RICH_TEXT,
        data?: any
    ) => {
        let greetingText = this.state.project.greetingText;
        const languageIndex = greetingText.findIndex(
            (greeting) => greeting.language === languageCode
        );
        debugger;
        let newContent;
        if (languageIndex > -1) {
            switch (type) {
                case MULTIMEDIA_TYPES.RICH_TEXT:
                    newContent = {
                        id: uuid.v4(),
                        type,
                        richText: createNewRichTextObject('')
                    };

                    break;
                case MULTIMEDIA_TYPES.IMAGE:
                case MULTIMEDIA_TYPES.VIDEO:
                case MULTIMEDIA_TYPES.AUDIO:
                    newContent = {
                        id: uuid.v4(),
                        type,
                        mediaURL: data?.mediaURL,
                        mediaOptions: { size: OPTION_SIZE.MEDIUM }
                    };
            }

            if (newContent) {
                greetingText[languageIndex].contents = [
                    ...greetingText[languageIndex].contents.slice(0, position),
                    newContent,
                    ...greetingText[languageIndex].contents.slice(position)
                ];
            }
        }

        this.setState(
            {
                project: {
                    ...this.state.project,
                    greetingText
                }
            },
            this.setEditFlag
        );
    };

    removeEditor = (languageCode: string, index: number) => {
        const greetingText = this.state.project.greetingText;
        const languageIndex = greetingText.findIndex(
            (questionText) => questionText.language === languageCode
        );

        if (languageIndex > -1) {
            greetingText[languageIndex].contents.splice(index, 1);

            this.setState(
                {
                    project: {
                        ...this.state.project,
                        greetingText
                    }
                },
                this.setEditFlag
            );
        }
    };

    onSave = async () => {
        if (this.state.isSaving) {
            return;
        }
        const checkValididity = this.isValid(); //TODO : This validation according to this page
        this.setState({
            isSaving: true,
            showError: true,
            questionError: checkValididity.errorObject
        });
        try {
            this.props.updateProject(
                this.props.currentProject.id,
                this.state.project
            );
            this.setState({
                isSaving: false
            });
            const newProjectData = {
                ...this.state.project,
                packageID: this.props.packageID
            };
            this.state.autoSavingService.setSyncedData(this.state.project);
            this.props.setProject(newProjectData);
            this.props.clearEditedStatus();
        } catch (e) {
            this.setState({
                isSaving: false
            });
            console.error(e);
            this.props.toastNotification.error(
                alertMessage.QUESTION_FORM_INVALID
            );
            this.props.clearEditedStatus(PROJECT_EDIT_STATUS.FAILED);
        }
    };

    cancelQuestion = async () => {
        if (!this.state.isSaving) {
            if (this.props.isEdited) {
                await getConfirmationBox({
                    message: alertMessage.CONFIRM_CONTINUE,
                    showCloseButton: true,
                    confirmButtonColor: '',
                    title: alertMessage.UNDO_CURRENT_CHANGE
                }).then((x) => {
                    if (!x.value) return;
                });
            }
            this.props.cancelEditQuestion();
        }
    };
    renderGreetingOption = (type: string) => {
        switch (type) {
            case 'default':
                return (
                    <Notes note="Default greeting message will be different based on local time" />
                );
                break;
            case 'image':
                return (
                    <GreetingImage
                        disabled={!this.props.editEnabled}
                        greetingImage={this.state.project.greetingImage}
                        setSelectMedia={this.setSelectedMedia}
                    />
                );
                break;
            case 'text':
                return (
                    <>
                        <input
                            type="text"
                            className="form-group__control"
                            placeholder=""
                            maxLength={30}
                            onChange={(
                                event: React.ChangeEvent<HTMLInputElement>
                            ) =>
                                this.setQuestion(
                                    'typistText',
                                    event.target.value
                                )
                            }
                            value={this.state.project.typistText}
                            disabled={!this.props.editEnabled}
                        />
                        <p className="form-group__info">
                            maximum characters: 30
                        </p>
                    </>
                );
                break;
        }
    };

    render() {
        const { project } = this.state;

        let greetingText = project.greetingText;
        if (typeof greetingText === 'string') {
            greetingText = null;
        }

        const projectError =
            (this.state.showError && this.state.projectError) || {};

        return (
            <React.Fragment>
                <div>
                    <div className="project-add--question-builder">
                        <BuilderHeader
                            isSettingBoxLayoutOpen={false}
                            showQuestionSetting={false}
                            showAlert={!this.props.editEnabled}
                            question={{ title: project.greetingLabel }}
                            setValue={(keyName, value) =>
                                this.setQuestion('greetingLabel', value)
                            }
                            disabled={!this.props.editEnabled}
                        />
                        <div className="builder-body">
                            <div className="row">
                                <div className="col-md-12 form-group-header">
                                    <HelperTooltip
                                        pathname="Question Text"
                                        placement="bottom"
                                        textSize="small"
                                        icon={true}
                                    >
                                        Question Text
                                    </HelperTooltip>
                                </div>
                            </div>
                            <MultimediaBubble
                                value={greetingText}
                                languages={this.props.currentProject?.languages}
                                keyName="greetingText"
                                setValue={this.setQuestion}
                                setValueWithLanguage={(
                                    keyName,
                                    value,
                                    l,
                                    index,
                                    type
                                ) =>
                                    this.setGreetingTexts(
                                        keyName,
                                        value,
                                        l,
                                        index,
                                        type
                                    )
                                }
                                addNewBubble={(l, position, type, data) =>
                                    this.addNewEditor(l, position, type, data)
                                }
                                removeBubble={(l, index) =>
                                    this.removeEditor(l, index)
                                }
                                hideQuestionTextLabel
                                questionError={projectError}
                                disabled={!this.props.editEnabled}
                                settings={{
                                    showClose: true,
                                    showDynamicReference: true
                                }}
                            />
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <div className="form-group-header">
                                        <label className="form-group__label form-group__label--block">
                                            Greeting text options
                                        </label>
                                    </div>

                                    <InputRadio
                                        options={[
                                            {
                                                label: 'Default',
                                                value: 'default'
                                            },
                                            {
                                                label: 'Greeting Image',
                                                value: 'image'
                                            },
                                            {
                                                label: 'Custom Greeting Text',
                                                value: 'text'
                                            }
                                        ]}
                                        disabled={!this.props.editEnabled}
                                        name="greetingType"
                                        selectedValue={
                                            this.state.project.greetingType
                                        }
                                        setValue={(value) =>
                                            this.setQuestion(
                                                'greetingType',
                                                value
                                            )
                                        }
                                    />
                                    {this.renderGreetingOption(
                                        this.state.project.greetingType ||
                                            'default'
                                    )}
                                    {projectError.greetingType ||
                                    projectError.greetingImage ||
                                    projectError.typistText ? (
                                        <span className="form-group__error-msg">
                                            {projectError.greetingType ||
                                                projectError.greetingImage ||
                                                projectError.typistText}
                                        </span>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (store: IApplicationState) => {
    const {
        projectReducer: { currentProject, packageID, editEnabled },
        utilsReducer: { isEdited, editStatus }
    } = store;
    return {
        currentProject,
        packageID,
        isEdited,
        editEnabled: editEnabled['question'],
        editStatus
    };
};

const mapDispatchToProps = (dispatch: any) => ({
    updateProject: (projectID: ProjectID, project: Project) =>
        dispatch(updateProject(projectID, project)),
    setProject: (newProject: Project) => {
        dispatch(Actions.setProject(newProject));
    },
    previewQuestion: (projectId: number, questionId: number) =>
        dispatch(previewQuestion(projectId, questionId)),
    setEditedStatus: (type: string, status: PROJECT_EDIT_STATUS) =>
        dispatch(setEditedStatus(type, status)),
    clearEditedStatus: (status?: PROJECT_EDIT_STATUS) =>
        dispatch(clearEditedStatus(status)),
    cancelEditQuestion: () => dispatch(cancelEditQuestion())
});

export default NotifyHOC(
    connect(mapStateToProps, mapDispatchToProps)(GreetingText)
);
